import { Card, Switch, Tooltip } from "antd";
import "./settings-card-item.scss";
import { ProjectSettingApi } from "@/entities/api/project/types";
import { formatMoscowDatetime } from "@/shared/utils";
import { UserBubble } from "@shared/ui";

interface ISettingsCardItem {
  settingsInfo: ProjectSettingApi.IntegrationSetting;
}

export const SettingsCardItem = ({ settingsInfo }: ISettingsCardItem) => {
  return (
    <Card className="project-setting-card" bordered={false}>
      <div className="project-setting-card-header">
        <h3 className="project-setting-card-title">
          {settingsInfo.integrationName}
        </h3>
        <Tooltip title="Для изменения перейдите в режим управления проектами">
          <Switch
            checked={settingsInfo.isCurrent}
            defaultChecked
            disabled
            className="project-setting-card-switch"
            style={{ marginTop: "0px" }}
          />
        </Tooltip>
      </div>

      {/* {description && (
        <p className="project-setting-card-description">{description}</p>
      )} */}
      <div className="project-setting-card-footer">
        <UserBubble userId={settingsInfo.updatedBy.userId}>
          <span className="project-setting-card-author">
            {`${settingsInfo.updatedBy.userFirstName} ${
              settingsInfo.updatedBy.userSurname
            } ${settingsInfo.updatedBy?.userMiddleName}`}
          </span>
        </UserBubble>

        <span className="project-setting-card-date">
          {formatMoscowDatetime(settingsInfo.updateDate)}
        </span>
      </div>
    </Card>
  );
};
